import { Box } from "@/components/essentials/box";
import { Typography } from "@/components/essentials/typography";
import { previewImageTestId } from "@/pages/_index/__components__/statuses/switch-statuses/preview/const";
import { VStack, Image, Flex, AspectRatio } from "@chakra-ui/react";
import { type FC, type ReactNode } from "react";
import Planner from "~/assets/images/planner.svg";

export interface ChatInputBoxProps {
  readonly title: string;
  readonly showChatBalloon: boolean;
  readonly children?: ReactNode;
}

export const ChatInputBox: FC<ChatInputBoxProps> = ({ title, showChatBalloon = false, children }) => {
  return showChatBalloon ? (
    <VStack gap={4}>
      <Flex width="100%" textAlign="left">
        <AspectRatio maxW="80px" w="20%" minW="40px" ratio={1}>
          <Image
            src={Planner}
            alt="プランナー"
            bgColor="mono.light.100"
            border="1px"
            borderColor="border.main"
            p="1"
            borderRadius="50%"
            mb="2"
            data-testid={previewImageTestId}
            objectFit="cover"
          />
        </AspectRatio>
        <Flex
          width="70%"
          minW="220px"
          bgColor="theme.orange.20"
          ml={2}
          px={8}
          py={4}
          borderRadius={40}
          borderBottomStartRadius={0}
          alignItems="center"
        >
          <Typography variant="display6">{title}</Typography>
        </Flex>
      </Flex>
      <Box width="100%" textAlign="right">
        <Box
          width="80%"
          minW="300px"
          display="inline-block"
          bgColor="theme.gray.1"
          px={8}
          py={6}
          borderRadius={40}
          borderBottomEndRadius={0}
          textAlign="left"
        >
          {children}
        </Box>
      </Box>
    </VStack>
  ) : (
    children
  );
};
